import React from 'react';
import { useAuth } from '../../context/AuthContext';

const PermissionGuard = ({ module, action, children, fallback = null }) => {
  const { hasPermission } = useAuth();
  return hasPermission(module, action) ? children : fallback;
};

export default PermissionGuard;
